import { FC } from "react";
import Modal from "components/Modal";
import { TicketStatusBadge, TicketMessageList } from "entities/support-ticket";
import type { SupportTicketDetail } from "entities/support-ticket";
import { CloseTicketButton } from "features/close-ticket";
import { ReplyTicketForm } from "features/reply-ticket";
import { useTicketThread } from "../model/useTicketThread";

import styles from "./TicketThreadModal.module.css";

interface Props {
  ticketId: number;
  onClose: () => void;
}

const TicketThread: FC<SupportTicketDetail> = ({ ticket, messages }) => (
  <div className={styles.thread}>
    <div className={styles.header}>
      <span className={styles.subject}>{ticket.subject}</span>
      <TicketStatusBadge status={ticket.status} />
    </div>
    <TicketMessageList messages={messages} />
    {ticket.can_reply ? (
      <>
        <ReplyTicketForm ticketId={ticket.id} />
        <CloseTicketButton ticketId={ticket.id} />
      </>
    ) : (
      <p className={styles.placeholder}>This request is closed.</p>
    )}
  </div>
);

export const TicketThreadModal: FC<Props> = ({ ticketId, onClose }) => {
  const { detail, isLoading, errorMessage } = useTicketThread(ticketId);

  return (
    <Modal
      isOpen
      onClose={onClose}
      title={`Request #${ticketId}`}
      className={styles.modal}
    >
      {isLoading && <p className={styles.placeholder}>Loading...</p>}
      {errorMessage && <p className={styles.placeholder}>{errorMessage}</p>}
      {detail && <TicketThread {...detail} />}
    </Modal>
  );
};
